export default __webpack_public_path__ + "static/media/screen3.a593cf0e.png";